// 用a链接导出处理方案GET方式
export function downloadALink(url,fileName){
    window.URL = window.URL || window.webkitURL;
    var xhr = new XMLHttpRequest();
    var a = document.createElement("a");
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function() {
        var file = new Blob([xhr.response], { type: "application/octet-stream" });
        a.href = window.URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    };
    xhr.send();
}



// 导出的流Blob,filename 导出的文件名
export function downloadFileBlob(data,filename) {
    if (!data) {
        return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
}